import { prefixerM } from '.'

export const ROUTE_CATEGORIAS_SERVICIO = prefixerM('categorias-servicio')
export const ROUTE_CREACION_PLANTILLA_SOLICITUD = prefixerM('creacion-plantilla-solicitud')
export const ROUTE_JEFE_AREA = prefixerM('jefe-area')
export const ROUTE_LINEAS_SERVICIO = prefixerM('lineas-servicio')
export const ROUTE_PLANTILLAS_SOLICITUD = prefixerM('plantillas-solicitud')
export const ROUTE_SERVICIOS = prefixerM('servicio')
